import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { formatDateTime } from '~/utils/date'
import prettyBytes from 'pretty-bytes'
import { DocumentType } from '@mutual-services/account-documents-types'
import { useIsMobileScreen } from '~/hooks'

const generateFileTypeLabel = (fileTypes: DocumentType[]) => {
  let formats = ''

  fileTypes.forEach(item => {
    if (item === DocumentType.document) {
      formats += `${formats.length ? ',' : ''} PDF`
    }

    if (item === DocumentType.photo) {
      formats += `${formats.length ? ',' : ''} PNG, JPG`
    }

    if (item === DocumentType.video) {
      formats += `${formats.length ? ',' : ''} MP4, MPG, AVI`
    }
  })

  return formats
}

export type InfoTextProps = {
  file?: File | null,
  isFileTooLarge?: boolean,
  completedAt?: Date | null | string,
  allowedDocumentTypes: DocumentType[]
}

const useStyles = makeStyles({
  blueText: {
    color: mutualTheme.palette.secondary.main,
    fontWeight: mutualTheme.typography.fontWeightMedium
  },
  infoText: {
    color: mutualTheme.palette.common.black,
    [mutualTheme.breakpoints.down('md')]: {
      color: mutualTheme.palette.textGray2.main
    }
  }
})

export const InfoText: React.FC<InfoTextProps> = (props) => {
  const { file, completedAt, allowedDocumentTypes, isFileTooLarge } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  if (isFileTooLarge) {
    return (
      <Typography className={classes.infoText} sx={{ marginLeft: isMobile ? 1 : 0 }} variant={isMobile ? 'airbnbBody3' : 'airbnbBody1'}>
        Arquivo excede o limite de 10MB
      </Typography>
    )
  }

  if (completedAt) {
    return (
      <Typography className={classes.infoText} sx={{ marginLeft: isMobile ? 1 : 0 }} variant={isMobile ? 'airbnbBody3' : 'airbnbBody1'}>
        Salvo em {formatDateTime(completedAt)}{isMobile ? '' : (completedAt ? <></> : <> • <span className={classes.blueText}>Enviar novamente</span></>)}
      </Typography>
    )
  }

  if (file && !isMobile) {
    return <Typography className={classes.infoText} sx={{ marginLeft: isMobile ? 1 : 0 }} variant={isMobile ? 'airbnbBody3' : 'airbnbBody1'}>{file.name} - {prettyBytes(file.size)}</Typography>
  }

  return (
    <Typography className={classes.infoText} sx={{ marginLeft: isMobile ? 1 : 0 }} variant={isMobile ? 'airbnbBody3' : 'airbnbBody1'}>
      {isMobile ? '' : <>Arraste e solte ou <span className={classes.blueText}>selecione o arquivo </span> {generateFileTypeLabel(allowedDocumentTypes)}</>}
    </Typography>
  )
}
